// extracted by mini-css-extract-plugin
var _1 = "OverflowMenu-module__menuContainer--_gDKK";
export { _1 as "menuContainer" }
